import { render } from "./Billing.vue?vue&type=template&id=1fc62bdd&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=1fc62bdd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc62bdd"]])

export default __exports__